import { useSelector } from 'react-redux'

import type { RootState } from '@web/app/store' // type-only import

export const useAppSelector = useSelector.withTypes<RootState>()
